<!--
 * @Description: 综合绩效管理
 * @Author: maqinghe 
 * @Date: 2023年06月26日 13:04:59
-->
<template>
  <div class='content-page atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="searchParam" ref="searchForm" :rules="rules" class="atb-input" :show-message="false" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="handledHide"
                trigger="click">
                <!-- <el-input v-model="searchDep" placeholder="请输入部门名称搜索" clearable></el-input> -->
                <el-tree
                  :props="defaultProps"
                  :data="treeData"
                  show-checkbox
                  node-key='id'
                  ref="tree"
                  highlight-current
                  :default-expanded-keys="expandedData"
                  @check="handleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="searchParam.superiorNo" placeholder="输入工号或姓名查询"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <el-input v-model="searchParam.wkName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="flex-form-item" label="评级">
              <el-select clearable v-model="searchParam.oecResult" placeholder="评级">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="最终结果状态">
              <common-select ref="status" v-model="searchParam.status" :list="oecStatusList" optLabel="itemDesc" optValue="itemValue" placeholder="状态" clearable></common-select>
            </el-form-item>
          </div>

          <div class="query-operation">
            <el-form-item label="年份" prop="year">
              <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
            </el-form-item>
            <el-form-item label="期次" prop="period">
              <common-select ref="period" v-model="searchParam.period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-upload ref="file" :http-request="uploadWorkscoreFile" :multiple="false" :show-file-list="false">
                <el-button type="export" style="width: 100px!important;">导入分类分数</el-button>
              </el-upload>
            </el-form-item> -->
            <el-form-item>
              <el-button type="export" @click="showTip">公示</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="downloadTemplate" @click="downloadTemplate">下载导入公示模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload ref="file" :http-request="uploadPublishFile" :multiple="false" :show-file-list="false">
                <el-button type="export">导入公示</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="downloadTemplate" @click="downloadCommentTemplate">下载维护参评模板</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-upload ref="file" :http-request="uploadCommentFile" :multiple="false" :show-file-list="false">
                <el-button type="export">导入维护参评</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="downloadTemplate" @click="downloadOutterTemplate">下载年计划考核成绩模板</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-upload ref="file" :http-request="uploadOutterFile" :multiple="false" :show-file-list="false">
                <el-button type="export">导入年计划考核成绩</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportWorkscore">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="downloadTemplate" style="width: 110px!important;" @click="exportTask">综合考核表导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="declareRemind" style="width: 110px!important;">结果提交提醒</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="approvalRemind" style="width: 110px!important;">结果审批提醒</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="tableCommitRemind" style="width: 110px!important;">考核表提交提醒</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="tableConfirmRemind" style="width: 110px!important;">考核表确认提醒</el-button>
            </el-form-item>
            <!-- <el-form-item class="multi-line">
              <el-button type="downloadTemplate" style="width: 110px!important;" @click="exportImportant">重要度排序导出</el-button>
            </el-form-item> -->
            <!-- <el-form-item class="multi-line">
              <el-button type="export" @click="notice">提醒确认年考核表</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="export" @click="notice">提醒填报最终结果</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="export" @click="notice">提醒填报重要度排序</el-button>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
      <div class="table-tabs">
        <div
          class="table-tab"
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{'table-tab--active': currentTab === tab.value}"
          @click="switchTab(tab.value)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class='table-content' v-show="currentTab === 0">
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table"
          :seq-config="{ seqMethod }"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" min-width="160" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toWorkscoreList(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              
              <!-- <span class="name-col" v-if="(row.category === 'Month' && row.workScoreInfo)" @click="toWorkscoreList(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="configWkInfo" title="排序人" width="150"></vxe-table-column> -->
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isEnable" title="是否有单独权重" width="150">
            <template #default="{row}">
              <span v-if="row.isEnable == 1">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <template v-if="row.category">
                <span v-if="row.isRatingCurnt">是</span>
                <span v-else>否</span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="noRatingReason" title="不参评原因" width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.noRatingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70">
            <template #default="{row}">
              <template v-if="row.category">
                <span>{{ row.score }}</span>
              </template>
            </template>
          </vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="最终结果状态" width="115" fixed="right">
            <template #default="{ row }">
              <template v-if="row.category">
                <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else type="ongoing" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>
              <template v-else>无</template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workscoreStatus" title="考核表状态" width="95" fixed="right">
            <template #default="{ row }">
              <template>
                <span class="name-col" v-if="row.workScoreInfo" @click="toWorkscorePage(row)">{{ workscoreStatusMap[row.workScoreInfo.status] || ''}}</span>
                <span class="name-col" v-else-if="row.yearScoreInfo" @click="toWorkscorePage(row)">{{ yearStatusMap[row.yearScoreInfo.status] || ''}}</span>
                <span v-else>无</span>
              </template>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="importantceStatus" title="重要度状态" width="95" fixed="right">
            <template #default="{ row }">
              <span class="name-col" @click="showImportancePage(row)">{{ statusMap[row.sortStatus]}}</span>
            </template>
          </vxe-table-column> -->
          <vxe-table-column field="" title="操作" class-name='operation' width="60" fixed="right">
            <template #default="scope">
              <template v-if="scope.row.category">
                <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                  <i class='icon-editor' @click.stop="startEdit(scope.row, 'table')"></i>
                </el-tooltip>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <!-- 年计划考核 -->
      <div class='table-content' v-show="currentTab === 1">
        <div class="collapse" @click="yearCollapse($refs.table1)" :style="{'right': yearCollapseRight}">
          <i :class="[isYearCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table1"
          :seq-config="{ seqMethod1 }"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" min-width="160" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toWorkscoreList(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <!-- <span class="name-col" v-if="(row.category === 'Month' && row.workScoreInfo)" @click="toWorkscoreList(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="configWkInfo" title="排序人" width="150"></vxe-table-column> -->
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isEnable" title="是否有单独权重" width="150">
            <template #default="{row}">
              <span v-if="row.isEnable == 1">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <template v-if="row.category">
                <span v-if="row.isRatingCurnt">是</span>
                <span v-else>否</span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="noRatingReason" title="不参评原因" width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.noRatingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70">
            <template #default="{row}">
              <template v-if="row.category">
                <span>{{ row.score }}</span>
              </template>
            </template>
          </vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="最终结果状态" width="115" fixed="right">
            <template #default="{ row }">
              <template v-if="row.category">
                <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else type="ongoing" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>
              <template v-else>无</template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workscoreStatus" title="考核表状态" width="95" fixed="right">
            <template #default="{ row }">
              <template>
                <span class="name-col" v-if="row.yearScoreInfo" @click="toWorkscorePage(row)">{{ yearStatusMap[row.yearScoreInfo.status] || ''}}</span>
                <span v-else>无</span>
              </template>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="importantceStatus" title="重要度状态" width="95" fixed="right">
            <template #default="{ row }">
              <span class="name-col" @click="showImportancePage(row)">{{ statusMap[row.sortStatus]}}</span>
            </template>
          </vxe-table-column> -->
          
          <!-- 折叠分数 -->
          <vxe-table-column
            v-for="classifyColumn in workClassifyColumns"
            :key="classifyColumn.field"
            :field="classifyColumn.field"
            width="110"
            :title="classifyColumn.name"
            :visible="isShowYearPlan"
            fixed="right"
          >
            <template #default="{row}">
              <div>{{row[classifyColumn.field]}}</div>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="classify0" width="110" title="重要KPI成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify0}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify10" width="100" title="业务成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify10}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify20" width="110" title="费效管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify20}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify30" width="150" title="人力资源管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify30}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify40" width="150" title="企业文化管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify40}}</div>
            </template>
          </vxe-table-column> -->

          <vxe-table-column field="" title="操作" class-name='operation' width="60" fixed="right">
            <template #default="scope">
              <template v-if="scope.row.category">
                <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                  <i class='icon-editor' @click.stop="startEdit(scope.row, 'table1')"></i>
                </el-tooltip>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>

      <!-- 员工绩效参考 -->
      <div class='table-content' v-show="currentTab === 2">
        <div class="collapse" @click="personCollapse($refs.table2)" :style="{'right': personCollapseRight}">
          <i :class="[isPersonCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table2"
          :seq-config="{ seqMethod2 }"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" min-width="160" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toWorkscoreList(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <!-- <span class="name-col" v-if="(row.category === 'Month' && row.workScoreInfo)" @click="toWorkscoreList(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="configWkInfo" title="排序人" width="150"></vxe-table-column> -->
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isEnable" title="是否有单独权重" width="150">
            <template #default="{row}">
              <span v-if="row.isEnable == 1">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <template v-if="row.category">
                <span v-if="row.isRatingCurnt">是</span>
                <span v-else>否</span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="noRatingReason" title="不参评原因" width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.noRatingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70">
            <template #default="{row}">
              <template v-if="row.category">
                <span>{{ row.score }}</span>
              </template>
            </template>
          </vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="最终结果状态" width="115" fixed="right">
            <template #default="{ row }">
              <template v-if="row.category">
                <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else type="ongoing" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>
              <template v-else>无</template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workscoreStatus" title="考核表状态" width="95" fixed="right">
            <template #default="{ row }">
              <template>
                <span class="name-col" v-if="row.workScoreInfo" @click="toWorkscorePage(row)">{{ workscoreStatusMap[row.workScoreInfo.status] || ''}}</span>
                <span v-else>无</span>
              </template>
            </template>
          </vxe-table-column>
          <!-- <vxe-table-column field="importantceStatus" title="重要度状态" width="95" fixed="right">
            <template #default="{ row }">
              <span class="name-col" @click="showImportancePage(row)">{{ statusMap[row.sortStatus]}}</span>
            </template>
          </vxe-table-column> -->
          
          <!-- 折叠分数 -->
          <vxe-table-column field="classify100" width="80" title="绩效成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify100}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify110" width="80" title="企业文化导向成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify110}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify120" width="80" title="个人成长成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify120}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify130" width="80" title="OEC综合成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify130}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-for="col in monthColumns"
            :field="col.field"
            :width="col.width"
            :title="col.title"
            :fixed="col.fixed"
            :visible="isShowPerson"
            :key="col.field"
            class-name='col-small'
            header-class-name='col-small'
          >
          </vxe-table-column>

          <vxe-table-column field="" title="操作" class-name='operation' width="60" fixed="right">
            <template #default="scope">
              <template v-if="scope.row.category">
                <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                  <i class='icon-editor' @click.stop="startEdit(scope.row, 'table2')"></i>
                </el-tooltip>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          v-show="currentTab === 0"
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 1"
          background
          :current-page.sync="yearPage.pageIndex"
          :page-size.sync="yearPage.pageSize"
          :total="yearTotal"
          height="100%"
          @page-change="yearPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 2"
          background
          :current-page.sync="personPage.pageIndex"
          :page-size.sync="personPage.pageSize"
          :total="personTotal"
          height="100%"
          @page-change="personPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="showConfirmTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要公示吗?</h2>
        <p style="line-height: 1.5;">{{tipMessage}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmTip">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showConfirmTip = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :propData="dialogContent.data" :param="commonParams" @callback="dialogCallback"></component>
      </template>
    </common-dialog>

    <el-dialog title="编辑" v-if="isShowEdit" :visible.sync="isShowEdit" width="600px" custom-class="changeDialog" @close="editClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-form ref="editForm" :model="editForm" label-width="130px" label-position="right" :rules="editFormRules">
          <el-form-item label="类型" prop="category">
            <el-select v-model="editForm.category">
              <el-option label="年计划考核" value="Year"></el-option>
              <el-option label="员工绩效考核" value="Month"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否参评" prop="isRatingCurnt">
            <el-select v-model="editForm.isRatingCurnt">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="不参评原因" prop="noRatingReason">
            <el-input
              :maxlength="$config.input.textareaMaxLength"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="editForm.noRatingReason"
              placeholder="不参评原因"
              clearable
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="总成绩" prop="score">
            <el-input v-model.trim="editForm.score" @change="validateFromScore('score')"></el-input>
          </el-form-item> -->
          <el-form-item label="评级" prop="ratingResult">
            <el-select v-model="editForm.ratingResult">
              <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="评级原因" prop="ratingReason">
            <el-input
              :maxlength="$config.input.textareaMaxLength"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="editForm.ratingReason"
              placeholder="评级原因"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              :maxlength="$config.input.textareaMaxLength"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8 }"
              v-model="editForm.remarks"
              placeholder="备注"
              clearable
            ></el-input>
          </el-form-item>
          <template v-if="currentTab === 1">
            <el-form-item v-for="classifyItem in workClassifyColumns" :key="classifyItem.field" :label="classifyItem.name" :prop="classifyItem.field">
              <el-input v-model.trim="editForm[classifyItem.field]" @change="validateFromScore(classifyItem.field)" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="重要KPI成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify0" @change="validateFromScore('classify0')" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify10" @change="validateFromScore('classify10')" clearable></el-input>
            </el-form-item>
            <el-form-item label="费效管理成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify20" @change="validateFromScore('classify20')" clearable></el-input>
            </el-form-item>
            <el-form-item label="人力资源管理成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify30" @change="validateFromScore('classify30')" clearable></el-input>
            </el-form-item>
            <el-form-item label="企业文化管理成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify40" @change="validateFromScore('classify40')" clearable></el-input>
            </el-form-item> -->
          </template>
          <template v-if="currentTab === 2">
            <el-form-item label="绩效成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify100" @change="validateFromScore('classify100')" clearable></el-input>
            </el-form-item>
            <el-form-item label="企业文化导向成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify110" @change="validateFromScore('classify110')" clearable></el-input>
            </el-form-item>
            <el-form-item label="个人成长成绩" prop="remarks">
              <el-input v-model.trim="editForm.classify120" @change="validateFromScore('classify120')" clearable></el-input>
            </el-form-item>
          </template>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmEdit">保存</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowEdit = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="exportDialog" title="期次范围选择" width="530px" showClose :appendBody="true">
      <template slot="content">
        <exportComponent :param="exportParams"></exportComponent>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  import {
    CLASSIFY_MAP,
    MANAGE_EDITDABLE_CLASSIFY,
    PERIODS,
    PERIOD_LIST,
    OEC_LEVEL,
    IMPORTANCE_STATE,
    WORK_SCORE,
    YEAR_PLAN_STATUS
  } from '@/utils/period-enum.js';
  import periodMixin from '@/mixins/period.mixin';
  export default {
    name: "workscoreManage",
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      importanceSort: () => import('./importanceSort'),
      exportComponent:()=>import('./export.vue'),
      DeclareRemind: () => import('./DeclareRemind.vue'),
      ApprovalRemind: () => import('./ApprovalRemind.vue'),
      TableConfirmRemind: () => import('./TableConfirmRemind.vue'),
      TableCommitRemind: () => import('./TableCommitRemind.vue'),
    },
    inject: ['reload'],
    mixins: [periodMixin],
    data() {
      return {
        currentPath: this.$route.path,
        tabs: [
          { name: '全部', value: 0, key: 'all', category: '' },
          { name: '年计划考核', value: 1, key: 'year', category: 'Year' },
          { name: '员工绩效考核', value: 2, key: 'person', category: 'Month' },
        ],
        currentTab: 0,
        isYearCollapse: true,
        isPersonCollapse: true,
        yearCollapseRight: 0,
        personCollapseRight: 0,
        oecStatusList: [
          { "itemValue": "0", "itemDesc": "未填报" },
          { "itemValue": "10", "itemDesc": "已驳回" },
          { "itemValue": "20", "itemDesc": "已填报" },
          { "itemValue": "30", "itemDesc": "已审批" },
          { "itemValue": "40", "itemDesc": "已公示" }
        ],
        classifyMap: CLASSIFY_MAP,
        editableClassify: MANAGE_EDITDABLE_CLASSIFY,
        workscoreStatusMap: WORK_SCORE,
        yearStatusMap: YEAR_PLAN_STATUS,
        
        periods: PERIODS,
        periodList: PERIOD_LIST,
        oecLevel: OEC_LEVEL,
        searchParam: {
          wkNo: '',
          wkName: '',
          superiorNo: '',
          oecResult: '',
          year: undefined,
          period: undefined,
          status: ''
        },
        declareForm: {
          wkNo: '',
        },
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],

        yearPage: {
          pageIndex: 1,
          pageSize: 10
        },
        yearTotal: 0,

        personPage: {
          pageIndex: 1,
          pageSize: 10
        },
        personTotal: 0,

        warnNum: 'warn-num',
        nomalNum: 'num',

        statusMap: IMPORTANCE_STATE,
  
        errMap: 1,
        
        currWkNo: '',
        wkNo: '',
        msgId: '',
        role: 1,

        isShowYearPlan: false,
        isShowPerson: false,
        monthColumns: [
          {field: 'm1', title: '1月',  width: 35, fixed: 'right'},
          {field: 'm2', title: '2月',  width: 35, fixed: 'right'},
          {field: 'm3', title: '3月',  width: 35, fixed: 'right'},
          {field: 'm4', title: '4月',  width: 35, fixed: 'right'},
          {field: 'm5', title: '5月',  width: 35, fixed: 'right'},
          {field: 'm6', title: '6月',  width: 35, fixed: 'right'},
          {field: 'm7', title: '7月',  width: 35, fixed: 'right'},
          {field: 'm8', title: '8月',  width: 35, fixed: 'right'},
          {field: 'm9', title: '9月',  width: 35, fixed: 'right'},
          {field: 'm10', title: '10月',  width: 40, fixed: 'right'},
          {field: 'm11', title: '11月',  width: 40, fixed: 'right'},
          {field: 'm12', title: '12月',  width: 40, fixed: 'right'},
        ],

        classifyPrefix: 'classify',

        showConfirmTip: false,
        tipMessage: '',

        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList:[],
        checkId:"",
        department:'',
        copyTreeData:[],
        departmentNo:'',
        expandedData:[],

        dialogContent: {
          width: '80%',
          componentName: 'importanceSort',
          title: '重要度排序',
          data: {}
        },

        isShowEdit: false,
        editForm: {},
        editFormRules: {},

        isDynamicEffective: true, // 是否启用动态版本
        isDynamicVersion: true,
        workClassifyColumns: [],

        commonParams: {},
      }
    },
    computed: {
      exportParams() {
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        return {
          loginWkNo: this.currWkNo,
          ...this.searchParam,
          year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
          period: this.searchParam.period || undefined,
          category,
          departmentNo: this.departmentNo
        }
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
      this.getDep();
      this.getList();
    },
    activated() {
      this.getList();
    },
    methods: {
      switchTab(tabIndex) {
        this.currentTab = tabIndex;
        this.getList();
      },
      yearCollapse(el) {
        this.isYearCollapse = !this.isYearCollapse;
        if (this.isYearCollapse) {
          this.hideYearPlan();
        } else {
          this.showYearPlan();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setYearPosition();
        });
      },
      showYearPlan() {
        this.isShowYearPlan = true;
      },
      hideYearPlan() {
        this.isShowYearPlan = false;
      },
      setYearPosition() {
        setTimeout(() => {
          if (this.isYearCollapse) {
            this.yearCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table1.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth - 305;
            this.yearCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      personCollapse(el) {
        this.isPersonCollapse = !this.isPersonCollapse;
        if (this.isPersonCollapse) {
          this.hidePerson();
        } else {
          this.showPerson();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setPersonPosition();
        });
      },
      showPerson() {
        this.isShowPerson = true;
      },
      hidePerson() {
        this.isShowPerson = false;
      },
      setPersonPosition() {
        setTimeout(() => {
          if (this.isPersonCollapse) {
            this.personCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table2.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth - 305;
            this.personCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      // 格式化序列号
      seqMethod({ rowIndex }) {
        return rowIndex + (this.page.pageIndex - 1) * this.page.pageSize + 1;
      },
      seqMethod1({ rowIndex }) {
        return rowIndex + (this.yearPage.pageIndex - 1) * this.yearPage.pageSize + 1;
      },
      seqMethod2({ rowIndex }) {
        return rowIndex + (this.personPage.pageIndex - 1) * this.personPage.pageSize + 1;
      },

      async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList=res.data||[];     
            const obj ={};
            this.depList.forEach(v=>{
             const objClone=_.cloneDeep(obj);
             objClone.id= v.id,
             objClone.code= v.code,
             objClone.label= v.displayName
           if(v.parentId===null){
              this.expandedData.push(v.id);
              objClone.children= this.depList.filter(t=>t.parentId===v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData=_.cloneDeep(this.treeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v=>{
          v.label= v.displayName
          v.children = this.depList.filter(t=>t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      handleCheckChange(){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
        // this.selectNode = this.formatToTree(selectData);
        // if(checked === true){
        //   this.checkId=data.id;
        //   this.departmentNo=data.code;
        //   this.department=data.label;
        //   // this.$refs.tree.setCheckedKeys([data.id]);
        // }else{
        //   if(this.checkId === data.id) {
        //     this.checkId='';
        //     this.departmentNo='';
        //     this.department='';
        //     // this.$refs.tree.setCheckedKeys([]);
        //   }
        // }
      },

      async getList(resetPage) {
        this.setValid(1);
        this.$refs['searchForm'].validate(async (valid, errors) => {
          if (valid) {
            if (resetPage) {
              this.page.pageIndex = 1;
              this.yearPage.pageIndex = 1;
              this.personPage.pageIndex = 1;
            }
            if (this.wkNo) {
              this.currWkNo = this.wkNo;
            }
            let page = this.page;
            switch (this.currentTab) {
              case 0:
                page = this.page;
                break;
              case 1:
                page = this.yearPage;
                break;
              case 2:
                page = this.personPage;
                break;
              default:
                break;
            }
            let tab = this.tabs.find(item => item.value === this.currentTab);
            let category = tab ? tab.category : '';
            let param = Object.assign(
              { loginWkNo: this.currWkNo, category },
              this.searchParam,
              {
                year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
                period: this.searchParam.period || undefined,
                departmentNo: this.departmentNo
              },
              page
            );

            await this.$ajax.post(this.$api.period.manage.list, param).then(async (res) => {
              let resList = res.data.rows || [];
              let tableDatas = [];
              resList.forEach(item => {
                let rowData = {
                  ...item.periodResultInfo,
                  ...item,
                  resultId: item.periodResultReturnList.resultId,
                  sortStatus: item.periodResultReturnList.sortStatus
                };
                let monthData = item.oecResultInfo || [];

                for (let i = 0; i < this.monthColumns.length; i++) {
                  rowData[this.monthColumns[i]] = '';
                }
                monthData.forEach(p => {
                  rowData['m' + p.month] = p.ratingResult || '';
                });

                let classifyData = item.periodClassifyScoreInfo || [];
                for (const key in this.classifyMap) {
                  rowData[this.classifyPrefix + key] = '';
                }
                classifyData.forEach(c => {
                  rowData[this.classifyPrefix + c.workClassify] = c.score;
                });

                tableDatas.push(rowData);
              });
              if (this.currentTab === 1) {
                this.handleDynamicColumn(res.data.classifyList || []);
              }
              this.tableData = tableDatas;
              
              switch (this.currentTab) {
                case 0:
                  this.total = res.data.total;
                  break;
                case 1:
                  this.yearTotal = res.data.total;
                  break;
                case 2:
                  this.personTotal = res.data.total;
                  break;
                default:
                  break;
              }
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        })
      },
      
      
      editClose() {
        this.getList();
      },
      handleDynamicColumn(dynamicWorkClassify) {
        let workClassifyColumns = [];
        const defaultColumns = [
          {field: `${this.classifyPrefix}0`, workClassify: 0, name: '重要KPI成绩' },
          {field: `${this.classifyPrefix}10`, workClassify: 10, name: '业务成绩' },
          {field: `${this.classifyPrefix}20`, workClassify: 20, name: '费效管理成绩' },
          {field: `${this.classifyPrefix}30`, workClassify: 30, name: '人力资源管理成绩' },
          {field: `${this.classifyPrefix}40`, workClassify: 40, name: '企业文化管理成绩' },
        ];
        if (dynamicWorkClassify.length > 0) {
          workClassifyColumns = dynamicWorkClassify.map((item) => {
            this.editableClassify.push(item.workClassify)
            return {
              field: `${this.classifyPrefix}${item.workClassify}`,
              workClassify: item.workClassify,
              name: item.classifyName
            }
          })
          this.editableClassify = [...new Set(this.editableClassify)];
        } else {
          workClassifyColumns = defaultColumns;
        }
        this.workClassifyColumns = workClassifyColumns;
      },
      
      startEdit(row) {
        // this.$refs[table].setActiveRow(row);
        this.isShowEdit = true;
        this.editForm = _.cloneDeep(row);
        this.editRow = row;
      },
      validateFromScore(key) {
        let val = this.editForm[key];
        if(!val) val = '';
        val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        if (val - 0 > 100) {
          val = '100';
        }
        if (val - 0 < 0) {
          val = '0';
        }
        this.editForm[key] = '' + val;
      },
      confirmEdit() {
        this.$refs.editForm.validate(async (valid) => {
          if (valid) {
            let rowSave = new Promise((resolve, reject) => {
              const {resultId, category, isRatingCurnt, noRatingReason, ratingResult, ratingReason, remarks} = this.editForm;
              this.$ajax.post(this.$api.period.manage.update, {resultId, category, isRatingCurnt, noRatingReason, ratingResult, ratingReason, remarks}).then(async() => {
                resolve(1);
              }).catch(() => {
                reject(0);
              });
            });
            let scoreSave = new Promise((resolve, reject) => {
              const changedClassify = [];
              this.editableClassify.forEach(key => {
                let scoreKey = this.classifyPrefix + key;
                if (this.editRow[scoreKey] != this.editForm[scoreKey]) {
                  changedClassify.push({
                    workClassify: key,
                    score: this.editForm[scoreKey] ? parseFloat(this.editForm[scoreKey]): null,
                    wkNo: this.editForm.wkNo,
                    wkName: this.editForm.wkName,
                    year: this.editForm.year,
                    period: this.editForm.period,
                  });
                }
              });
              if (changedClassify.length > 0) {
                this.$ajax.post(this.$api.period.manage.growUpUpdateClassify, changedClassify).then(() => {
                  resolve(1);
                }).catch(() => {
                  reject(0);
                });
              } else {
                resolve(1);
              }
            });
            let promises = [rowSave];
            if (this.currentTab !== 0) {
              promises.push(scoreSave);
            }

            Promise.all(promises).then(() => {
              this.$message.success("保存成功");
              this.isShowEdit = false;
              this.getList();
            });
          } else {
            return false;
          }
        });
      },

      
      pageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      yearPageChange({currentPage}) {
        this.yearPage.pageIndex = currentPage;
        this.getList();
      },
      personPageChange({currentPage}) {
        this.personPage.pageIndex = currentPage;
        this.getList();
      },
      toWorkscoreList(row) {
        this.$router.push({path: '/period/manage/workscoreList', query: { wkNo: row.wkNo }});
      },

      toWorkscorePage(row) {
        if (row.category === 'Month') {
          this.$router.push({path: '/period/manage/workscore', query: { id: row.workScoreInfo.id }});
        } else if (row.category === 'Year') {
          let pagePath = '/period/manage/yearWorkscore';
          if (this.isDynamicEffective && row.yearScoreInfo.versionId) {
            pagePath = '/period/manage/yearWorkScoreNext';
          }
          this.$router.push({path: pagePath, query: { id: row.yearScoreInfo.id }});
        }
      },
      exportWorkscore() {
        this.$refs['searchForm'].validate((valid) => {
          if (valid) {
            this.$ajax
              .get(this.$api.period.manage.exportTaskApi, this.exportParams)
              .then((res) => {
                if (res.code === 0) {
                  this.$router.push({
                    path: '/manage/export-task/index',
                  });
                }
              })
              .catch(() => {});
          }
        })
      },
      exportMulti(){
        this.$refs.exportDialog.show();
      },
      // 导入评分表
      uploadWorkscoreFile() {

      },
      // 公示
      showTip(){
        let page = this.page;
        switch (this.currentTab) {
          case 0:
            page = this.page;
            break;
          case 1:
            page = this.yearPage;
            break;
          case 2:
            page = this.personPage;
            break;
          default:
            break;
        }
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        let param = Object.assign(
          { loginWkNo: this.currWkNo, category },
          this.searchParam,
          {
            year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
            period: this.searchParam.period || undefined,
            departmentNo: this.departmentNo
          },
          page
        );
        this.$ajax.post(this.$api.period.manage.tip, param, {noLoading: true}).then((res) => {
          this.tipMessage = res.message;
        }).finally(() => {
            this.showConfirmTip = true;
        });
      },
      confirmTip() {
        let page = this.page;
        switch (this.currentTab) {
          case 0:
            page = this.page;
            break;
          case 1:
            page = this.yearPage;
            break;
          case 2:
            page = this.personPage;
            break;
          default:
            break;
        }
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        let param = Object.assign(
          { loginWkNo: this.currWkNo, category },
          this.searchParam,
          {
            year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
            period: this.searchParam.period || undefined,
            departmentNo: this.departmentNo
          },
          page
        );
        this.$ajax.post(this.$api.period.manage.confirmTip, param).then((res) => {
          if (res.code === 0) {
            this.$router.push({
              path: '/manage/export-task/index',
            });
          }
        }).finally(()=>{
          this.showConfirmTip = false;
        });
      },
      downloadTemplate() {
        window.location.href = process.env.VUE_APP_PUBLICPATH + 'files/综合绩效管理导入公示模板.xlsx';
      },
      uploadPublishFile({ file }) {
        const params = new FormData();
        params.append('excelfile', file);
        this.$ajax.put(this.$api.period.manage.importTip, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
          if (res.code === 0) {
            this.$message.success('上传成功');
            this.getList(1);
          }
        });
      },
      downloadCommentTemplate() {
        window.location.href = process.env.VUE_APP_PUBLICPATH + 'files/综合绩效管理维护参评模板.xlsx';
      },
      uploadCommentFile({ file }) {
        const params = new FormData();
        params.append('excelfile', file);
        this.$ajax.put(this.$api.period.manage.importComment, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
          if (res.code === 0) {
            this.$message.success('上传成功');
            this.getList(1);
          }
        });
      },

      // 年计划导入外部分数模板
      downloadOutterTemplate() {
        this.setValid(1);
        this.$refs['searchForm'].validate((valid, errors) => {
          if (valid) {
            let param = {};
            if (this.searchParam.year && this.searchParam.period) {
              param = {year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined, period: this.searchParam.period || undefined}
            }
            this.$ajax.post(this.$api.period.yearWeight.getClassify, param).then((res) => {
              const classifys = res.data || [];
              this.isDynamicVersion = classifys && classifys.length > 0;
              if (this.isDynamicVersion) {
                window.location.href = process.env.VUE_APP_PUBLICPATH + 'files/yearnext/年计划考核导入成绩模板.xlsx';
              } else {
                window.location.href = process.env.VUE_APP_PUBLICPATH + 'files/年计划考核导入成绩模板.xlsx';
              }
            })
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
        });
        this.setValid(0);
      },
      uploadOutterFile({ file }) {
        const params = new FormData();
        params.append('excelfile', file);
        this.$ajax.post(this.$api.period.manage.importOutterData, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
          if (res.code === 0) {
            this.$message.success('上传成功');
            this.getList(1);
          }
        });
      },
      // 提醒
      notice() {

      },

      // 打开重要度排序弹窗
      showImportancePage(row) {
        this.dialogContent.data = row;
        this.$refs.commonDialog.show();
      },
      dialogCallback() {

      },

      exportTask() {
        this.setValid(1);
        this.$refs['searchForm'].validate((valid, errors) => {
          if (valid) {
            let queryWhere = _.cloneDeep(this.searchParam);
            let tab = this.tabs.find(item => item.value === this.currentTab);
            let category = tab ? tab.category : '';
            queryWhere = {
              ...queryWhere,
              loginWkNo: this.currWkNo,
              category,
              year: queryWhere.year ? parseInt(queryWhere.year) : undefined,
              period: queryWhere.period || undefined,
              departmentNo: this.departmentNo
            };
            this.$ajax
              .get(this.$api.period.manage.taskExport, queryWhere)
              .then((res) => {
                if (res.code === 0) {
                  this.$router.push({
                    path: '/manage/export-task/index',
                  });
                }
              })
              .catch(() => {});
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        })
      },
      exportImportant() {
        this.setValid(1);
        this.$refs['searchForm'].validate(async (valid, errors) => {
          if (valid) {
            this.$ajax.post(this.$api.period.manage.importantSortExport, this.exportParams, {ignore: true, responseType: 'blob'}).then((res) => {
              if (res.data.type == 'application/json') {
                var reader = new FileReader();
                reader.onload = () => {
                  var content = reader.result;//内容就在这里
                  let json = JSON.parse(content)
                  this.$message.error(json.message)
                };
                reader.readAsText(res.data);
              } else {
                const filename = '重要度排序'
                const filetype = 'xlsx'
                let data = res.data;
                let url = window.URL.createObjectURL(data)
                let a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.download = filename + '.' + filetype
                a.click()
                window.URL.revokeObjectURL(url)
              }
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        })
      },
      expandRow({row, triggerTreeNode}) {
        if (triggerTreeNode) return;
        row.expandRowFlag = !row.expandRowFlag;
        let $table = this.$refs.table;
        if (this.currentTab === 1) {
          $table = this.$refs.table1;
        } else if (this.currentTab === 2) {
          $table = this.$refs.table2;
        }
        $table.updateData(this.tableData);
      },
      getYearPeriod() {
        let year = this.searchParam.year ? parseInt(this.searchParam.year) : undefined;
        let period = this.searchParam.period || undefined;
        if (!year && !period && this.tableData.length > 0) {
          const firstRowPeriodInfo = this.tableData[0].periodResultInfo || {};
          year = firstRowPeriodInfo.year;
          period = firstRowPeriodInfo.period;
        }
        return {year, period};
      },
      declareRemind() {
        const {year, period} = this.getYearPeriod();
        this.commonParams = {
          ...this.page,
          ...this.searchParam,
          departmentNo: this.departmentNo,
          year,
          period,
        };
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'DeclareRemind',
          width: '720px'
        }
        this.$refs.commonDialog.show()
      },
      approvalRemind() {
        const {year, period} = this.getYearPeriod();
        this.commonParams = {
          ...this.page,
          ...this.searchParam,
          departmentNo: this.departmentNo,
          year,
          period,
        };
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'ApprovalRemind',
          width: '720px'
        }
        this.$refs.commonDialog.show()
      },
      tableCommitRemind() {
        const {year, period} = this.getYearPeriod();
        this.commonParams = {
          ...this.page,
          ...this.searchParam,
          departmentNo: this.departmentNo,
          year,
          period,
        };
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'TableCommitRemind',
          width: '720px'
        }
        this.$refs.commonDialog.show()
      },
      tableConfirmRemind() {
        const {year, period} = this.getYearPeriod();
        this.commonParams = {
          ...this.page,
          ...this.searchParam,
          departmentNo: this.departmentNo,
          year,
          period,
        };
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'TableConfirmRemind',
          width: '720px'
        }
        this.$refs.commonDialog.show()
      },

    },
    watch: {
      $route() {
        if (this.$route.path === this.currentPath) {
          this.reload();
        }
      },
      department: {
        handler(val){
          if(!val){
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate:true
      }
    },
  }
</script>
<style scoped lang='scss'>
  .content-page {
    height: 100%;
    .search-wrap {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
          flex-wrap: wrap;
          .flex-form-item {
            display: flex;
            flex: 1;
            max-width: 300px;
          }
          ::v-deep.el-form-item__label {
            white-space: nowrap;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
            .el-date-editor {
              min-width: 120px;
            }
            .el-select {
              min-width: 80px;
            }
          }
        }
      }
    }
    .table-content {
      position: relative;
    }
    .atb-content-bg {
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    .summary {
      margin-bottom: 12px;
      font-size: 14px;
      color: #4a5150;
      .item-data {
        margin-right: 40px;
        .cursor{
          cursor: pointer;
        }
        .num {
          font-weight: bolder;
          color: #22b6a1;
          padding: 10px;
        }
        .warn-num {
          font-weight: bolder;
          color: #fe6562;
          padding: 10px;
        }
      }
    }
  }
  .name-col {
    cursor: pointer;
    color: $--color-primary;
  }
  .collapse {
    margin-top: -15px;
    position: absolute;
    top: 50%;
    right: 0;
    width: 15px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: rgba(#000, 0.1);
    z-index: 99;
    cursor: pointer;
    &:hover {
      background-color: rgba(#000, 0.2);
    }
    i {
      font-size: 14px;
      color: #fff;
    }
  }
  .table-tabs {
    .table-tab {
      display: inline-block;
      margin: 0 8px 12px;
      padding: 8px 10px;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid $--color-primary;
      background-color: #d8f5f1;
      color: $--color-primary;
      &:hover, &.table-tab--active {
        background-color: $--color-primary;
        color: #fff;
      }
    }
    
  }
  .el-form-item.multi-line {
    ::v-deep .el-form-item__content {
      line-height: inherit;
    }
    .el-button.el-button--export, .el-button.el-button--downloadTemplate {
      width: 95px!important;
      white-space: normal;
      padding: 5px 2px;
      min-height: 40px;
    }
  }
  .el-dialog.changeDialog{
    .content{
      height: 500px;
      overflow: auto;
      .el-date-editor, .el-autocomplete{
        width: 100%;
      }
    }
    .el-select{
      width: 100%;
    }
    .write-summary{
      height: 150px;
    }
  }
</style>